<template>
	<div :class="['posted-date', {'chip':is_new} ]">{{ compute_display }}</div>
</template>

<script>
import { formatDistanceStrict } from 'date-fns';
import ls from 'localstorage-slim';

export default {
	props: {
		posted_date: {
			type: Number
		},
		job_id: {
			type: String
		}
	},

	data() {
		return {
			threeDays: (1000*60*60*24*3), // 3 days
      thirtyDays: (1000*60*60*24*30), // 30 days
			is_new: false
		}
	},

	computed: {
		formatted_date() {
      if (this.posted_date) {
        return formatDistanceStrict(this.posted_date, Date.now(), {addSuffix: true});
      }
      return '';
    },

		compute_display() {
      this.is_new = false;

      if ((Date.now() - this.posted_date) > this.thirtyDays) {
        return '> 30 days ago';
      }
      else if ((Date.now() - this.posted_date) < this.threeDays) {
				let seen_jobs = ls.get('esc_seen', { decrypt: false });
				if (seen_jobs && Object.keys(seen_jobs).includes(this.job_id)) {
          return this.formatted_date;
				}
				this.is_new = true;
				return 'NEW';
      }
      else {
        return this.formatted_date;
      }
		}
	}
}
</script>
